import { gql } from '@apollo/client';

export const DELETE_USER = gql`
  mutation DeleteUser($userId: ID!) {
    deleteUser(userId: $userId) {
      name
      deleted
      reason
    }
  }
`;
